import { getClosedTransactionDetail } from '../../../services/pos/transactions';
import actionTypes from '../constants/actionTypes';

export const getTransactionDetailAction = (transactionId) => async (dispatch) => {
  const { TRANSACTION_DATA_FETCH, TRANSACTION_DATA_SUCCESS, TRANSACTION_DATA_ERROR } = actionTypes;
  dispatch({ type: TRANSACTION_DATA_FETCH });
  try {
    const payload = await getClosedTransactionDetail(transactionId);
    dispatch({ type: TRANSACTION_DATA_SUCCESS, payload: payload });
  } catch (error) {
    const errorResponse = error.response;
    dispatch({ type: TRANSACTION_DATA_ERROR, error: errorResponse });
  }
};
